import { Stack, Typography } from '@mui/joy';
import { PencilSimpleLine, TrashSimple } from '@phosphor-icons/react';

import { NotificationPosition } from 'core/enums';
import { RemoveUserButton, UpsertUserButton } from 'projects/components/ProjectDetails';
import { IProjectUser } from 'projects/types';
import { Color, Direction, Level } from 'theme/enums';

interface IProps {
  projectId: number;
  data: IProjectUser;
}

export const ActionsCell = ({ projectId, data }: IProps) => {
  if (!data || data.isOwner) {
    return null;
  }

  return (
    <Stack direction={Direction.ROW} gap={1}>
      <UpsertUserButton
        projectId={projectId}
        user={data}
        buttonElement={
          <Typography color={Color.PRIMARY} level={Level.BODY_SM} sx={{ cursor: 'pointer' }}>
            <PencilSimpleLine />
          </Typography>
        }
      />
      <RemoveUserButton
        projectId={projectId}
        users={[data]}
        buttonElement={
          <Typography color={Color.DANGER} level={Level.BODY_SM} sx={{ cursor: 'pointer' }}>
            <TrashSimple />
          </Typography>
        }
        notificationPosition={NotificationPosition.TOP}
      />
    </Stack>
  );
};
